import { Button } from 'components/button/Button';
import { Form, Formik } from 'formik';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from 'reducers/modal';
import { setInstructionsUnderstood } from 'reducers/virtualAssessments';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

export const VirtualAssessmentsBeforeYouBeginModal = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation(
    ['Virtual+Assessments+Before+You+Begin+Modal', 'Panel+Buttons'],
    { i18n }
  );

  useEffect(() => {
    dispatch(setInstructionsUnderstood(false));
  }, []);

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleStartPQ = () => {
    dispatch(setInstructionsUnderstood(true));
    dispatch(closeModal());
  };

  const modalStyle = {
    '--modalTitleColor': '#036C8F',
    '--footerBackgroundColor': '#f5f5f5',
    '--footerBorderColor': '#f5f5f5',
    '--primaryButtonBackgroundColor': '#731447',
    '--tertiaryButtonBackgroundColor': '#d5d5d5',
  } as React.CSSProperties;

  return (
    <div className="VirtualAssessmentsBeforeYouBeginModal" style={modalStyle}>
      <Formik initialValues={{}} onSubmit={() => {}}>
        <Form>
          <div className="VirtualAssessmentsBeforeYouBeginModal__content VirtualAssessmentsModalContent">
            <div className="VirtualAssessmentsBeforeYouBeginModal__message">
              {t(
                'SSCandidate_Virtual_Assessments_Before_You_Begin_Modal_Message'
              )}
            </div>
          </div>
          <div className="ModalFooter">
            <Button
              className="Rounded"
              priority="tertiary"
              type="button"
              onClick={handleCloseModal}
            >
              {t('SSCandidate_Panel_Buttons_Cancel', { ns: 'Panel+Buttons' })}
            </Button>
            <Button
              className="Discard Rounded"
              priority="primary"
              type="submit"
              onClick={handleStartPQ}
            >
              {t(
                'SSCandidate_Virtual_Assessments_Before_You_Begin_Modal_I_Understand'
              )}
            </Button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};
